var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoldEditComments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 19 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,19.5C0,19.8,0.2,20,0.5,20h17.2 c0.3,0,0.5-0.2,0.5-0.5c0-4.1-4.1-7.5-9.1-7.5S0,15.4,0,19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1,0C7.7,0,6.4,0.6,5.5,1.5C4.6,2.4,4.1,3.7,4.1,5c0,0.9,0.3,1.8,0.7,2.6C5.1,8,5.4,8.4,5.8,8.7 c0.9,0.8,2,1.3,3.3,1.3c1.8,0,3.4-1,4.3-2.4c0.3-0.4,0.5-0.9,0.6-1.4C14,5.8,14.1,5.4,14.1,5c0-1.3-0.5-2.5-1.3-3.3 C11.9,0.6,10.6,0,9.1,0z M7.2,4.4C6.7,4.4,6.3,4,6.3,3.5s0.4-0.9,0.9-0.9H11c0.5,0,0.9,0.4,0.9,0.9S11.5,4.4,11,4.4H7.2z M9.1,7.5H7.2C6.7,7.5,6.3,7,6.3,6.5c0-0.5,0.4-0.9,0.9-0.9h1.9c0.5,0,0.9,0.4,0.9,0.9C10.1,7,9.7,7.5,9.1,7.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldEditComments);
export default __webpack_public_path__ + "static/media/bold-edit-comments.80ede1f09821a7190afe9aca89be8962.svg";
export { ForwardRef as ReactComponent };